import React, { useState, useEffect, useRef } from "react";
import CrossIcon from "assets/svg/cross-icon";
import Button from "components/button/Button";
import { Link } from "react-router-dom";
import ArrowLeftIcon from "assets/svg/arrow-left-icon";
import ChevronDownIcon from "assets/svg/chevron-down-icon";
import WhatsAppIcon from "assets/svg/whatsapp-icon";
import PhoneSolidIcon from "assets/svg/phone-solid-icon";
import LanguageMenu from "./LanguageMenu";
import UKFlagIcon from "assets/svg/uk-flag-icon";
import { trackEvents } from "utils/amplitude/amplitude";

const lifeAtDowningData = [
  {
    id: "student-life-at-the-railyard",
    name: "Student Life at The Railyard",
    slug: "student-life-at-the-railyard",
  },
  {
    id: "refer-a-friend",
    name: "Refer a Friend",
    slug: "friend",
  },
  {
    id: "special-needs",
    name: "Student requiring additional support",
    slug: "special-needs",
  },
  {
    id: "wellness-welfare",
    name: "Wellness/Welfare",
    slug: "wellness-welfare",
  },
];

const languageOptions = [
  {
    value: "en",
    label: "English",
    flag: UKFlagIcon,
  },
];

const HamburgerMenu = ({
  isOpen,
  onClose,
  logo,
  cityData,
  languageOptions: propLanguageOptions,
  selectedLanguage: propSelectedLanguage,
  onLanguageSelect,
}) => {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    propSelectedLanguage || languageOptions[0]
  );
  const languageMenuRef = useRef(null);
  const languageToggleRef = useRef(null);

  const options = propLanguageOptions || languageOptions;

  useEffect(() => {
    if (propSelectedLanguage) {
      setSelectedLanguage(propSelectedLanguage);
    }
  }, [propSelectedLanguage]);

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  const handleLanguageSelect = (option) => {
    if (selectedLanguage.value !== option.value) {
      setSelectedLanguage(option);
      if (onLanguageSelect) {
        onLanguageSelect(option);
      } else {
        localStorage.setItem("locale", option.value);
        window.location.reload();
      }
    }
    setIsLanguageMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        languageMenuRef.current &&
        !languageMenuRef.current.contains(event.target) &&
        languageToggleRef.current &&
        !languageToggleRef.current.contains(event.target) &&
        isLanguageMenuOpen
      ) {
        setIsLanguageMenuOpen(false);
      }
    };

    if (isLanguageMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLanguageMenuOpen]);

  const FlagIcon = selectedLanguage?.flag;

  const navigationOptions = [
    {
      id: "cities",
      text: "Cities",
      link: null,
      icon: ChevronDownIcon,
      menuData: cityData,
      menuType: "cities",
    },
    {
      id: "life-at-the-railyard",
      text: "Life at The Railyard",
      link: null,
      icon: ChevronDownIcon,
      menuData: lifeAtDowningData,
      menuType: "life-at-the-railyard",
    },
    { id: "about", text: "About us", link: "/about-us" },
    {
      id: "parent",
      text: "Parent Support",
      link: "/parent",
    },
    // {
    //   id: "rebook",
    //   text: "Rebooking",
    //   link: "/the-railyard-rebook",
    // },
    { id: "offers", text: "Offers", link: "/offers" },
    // {
    //   id: "summer-stays",
    //   text: "Summer Stays",
    //   link: "/summer-stays",
    // },

    { id: "faqs", text: "FAQs", link: "/faqs" },
    {
      id: "login",
      text: "Login",
      link: "https://bookings.downingstudents.com/Pages/Lander.aspx?wf=Login",
      target: "_blank",
      mobileOnly: true,
    },
    { id: "contact-us", text: "Contact us", link: "/contact-us" },
    // {
    //   id: "resident-login",
    //   text: "Resident login",
    //   link: "/",
    //   icon: null,
    //   onClick: () => {
    //     window.open(
    //       "https://bookings.downingstudents.com/Pages/Lander.aspx?wf=Login",
    //       "_blank"
    //     );
    //   },
    // },
    // { id: "blog", text: "Blog", link: "/blog-listing" },
  ];

  const handleSubmenuClick = (option) => {
    if (option.menuData) {
      setActiveSubmenu(option);
    } else if (option.link) {
      window.open(option.link, "_blank");
      // navigate(option.link);
      onClose();
    }
  };

  const handleCityClick = (city) => {
    if (!city) return;

    //const cityName = city?.name?.toLowerCase();

    // if (cityName?.includes("cambridge")) {
    //   window.open(
    //     "https://www.therailyard.co.uk/student-accommodation/cambridge/",
    //     "_blank"
    //   );
    //   onClose();
    //   setActiveSubmenu(null);
    //   return;
    // }

    if (!city?.slug) return;

    window.open(`/`, "_blank");
    // navigate(`/${city.slug}`);
    onClose();
    setActiveSubmenu(null);
  };

  const handlePropertyClick = (city, property) => {
    if (!city || !property) return;

    const propertyName = property?.name?.toLowerCase();

    // if (propertyName?.includes("railyard")) {
    //   window.open(
    //     "https://www.therailyard.co.uk/student-accommodation/cambridge/the-railyard/",
    //     "_blank"
    //   );
    //   onClose();
    //   setActiveSubmenu(null);
    //   return;
    // }

    if (propertyName?.includes("square")) {
      window.open(`/manchester/square-gardens`, "_blank");
      // navigate(`/manchester/square-gardens`);
      onClose();
      setActiveSubmenu(null);
      return;
    }

    if (!city?.slug || !property?.slug) return;

    window.open(`/${city.slug}/${property.slug}`, "_blank");
    // navigate(`/${city.slug}/${property.slug}`);
    onClose();
    setActiveSubmenu(null);
  };

  const handleLifeAtDowningClick = (item) => {
    if (!item?.slug) return;
    window.open(`/${item.slug}`, "_blank");
    // navigate(`/${item.slug}`);
    onClose();
    setActiveSubmenu(null);
  };

  const renderSubmenu = (option) => {
    if (!option.menuData) return null;

    const isLifeAtRailyard = option.menuType === "life-at-the-railyard";
    const isCities = option.menuType === "cities";

    return (
      <div className="flex flex-col h-full relative z-[103] bg-primary-bg">
        {/* Header */}
        <div className="h-[55px] lg:h-[80px] px-[16px] shadow-hamburger-menu-shadow bg-primary-black flex justify-between items-center flex-shrink-0">
          <Link to="/" onClick={onClose}>
            <img
              src={logo}
              alt="Company Logo"
              className="w-[83px] h-[24px] xxs:w-[93px] xxs:h-[24px] md:w-[127px] md:h-[42px] shrink-0"
            />
          </Link>

          <div className="flex items-center gap-[4px] xxs:gap-[8px] lg:gap-[12px]">
            <Button
              innerText="Find Rooms"
              innerClass="text-pure-white hover:text-primary-black font-bold text-[12px] md:text-[14px] shrink-0"
              outerClass="shadow-btn-shadow border-secondary-rectangle-one hover:border-pure-white curved-hover flex items-center justify-center border border-secondary-rectangle-one h-[30px] w-fit md:h-[36px] md:w-[120px] rounded-[8px] px-[12px] py-[8px] lg:px-[18px] 2xl:px-[28px] 2xl:py-[12px] bg-secondary-rectangle-one"
              outerStyle={{
                "--hover-bg-color": "#ffffff",
                "--hover-text-color": "#000000",
              }}
              onClick={() => {
                trackEvents("enquire_header_clicked");

                //navigate("/find-your-room/move-in");
                window.open(`/find-your-room/move-in`, "_blank");
              }}
            />
            <div
              className={`mr-8 xxs:mr-10 px-[8px] xxs:px-[12px] w-[60px] xxs:w-[72px] h-[30px] rounded-full lg:hidden flex items-center justify-between border border-secondary-gray/30 bg-pure-white/15`}
            >
              <button>
                <WhatsAppIcon
                  className={`w-[12px] h-[12px] xxs:w-[16px] xxs:h-[16px] text-pure-white`}
                />
              </button>
              <p className="text-secondary-gray/30">|</p>
              <button>
                <PhoneSolidIcon
                  className={`w-[12px] h-[12px] xxs:w-[14px] xxs:h-[14px] text-pure-white`}
                />
              </button>
            </div>
            <button onClick={onClose}>
              <CrossIcon className="w-[16px] h-[16px] text-pure-white shrink-0" />
            </button>
          </div>
        </div>

        {/* Back button + title */}
        <div className="flex-1 flex flex-col gap-[12px] min-h-0 px-[16px] py-[30px]">
          <div className="flex items-center gap-[8px]">
            <button
              onClick={() => setActiveSubmenu(null)}
              className="w-[24px] h-[24px] shrink-0 bg-primary-black border border-primary-black rounded-full flex justify-center items-center"
            >
              <ArrowLeftIcon className="w-[12px] h-[12px] text-pure-white" />
            </button>
            <h2
              onClick={() => {
                if (isCities) {
                  window.open(`/city-listing`, "_blank");
                  // navigate("/city-listing");
                  onClose();
                }
              }}
              className={`w-fit text-primary-black font-bold text-[24px] uppercase ${
                isCities
                  ? "hover:text-secondary-rectangle-one cursor-pointer"
                  : ""
              }`}
            >
              {option.text}
            </h2>
          </div>

          {/* Menu list */}
          <div className="flex-1 overflow-y-auto no-scrollbar py-[12px] [--webkit-overflow-scrolling:touch]">
            {Array.isArray(option.menuData) &&
              option.menuData.map((item, index) => {
                if (item?.isVisible === false) {
                  return null;
                }

                // Render Life at Railyard items
                if (isLifeAtRailyard) {
                  return (
                    <div
                      key={item.id || index}
                      className={`py-[12px] ${
                        index === option.menuData.length - 1
                          ? "border-b-0"
                          : "border-b-[1px] border-secondary-gray"
                      }`}
                    >
                      <p
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLifeAtDowningClick(item);
                        }}
                        className="w-fit font-medium text-[16px] text-primary-black md:hover:text-secondary-rectangle-one select-none cursor-pointer"
                      >
                        {item.name}
                      </p>
                    </div>
                  );
                }

                // Render Cities items
                if (isCities) {
                  return (
                    <div
                      key={item.id || index}
                      className={`py-[12px] ${
                        index === option.menuData.length - 1
                          ? "border-b-0"
                          : "border-b-[1px] border-secondary-gray"
                      }`}
                    >
                      <p
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCityClick(item);
                        }}
                        className="w-fit uppercase font-bold text-[16px] text-primary-black md:hover:text-secondary-rectangle-one select-none cursor-pointer"
                      >
                        {item.name || item.title || item.text}
                      </p>

                      {Array.isArray(item.properties) &&
                        item.properties.length > 0 && (
                          <div className="pt-[6px] flex items-center gap-[12px] text-[14px] text-primary-black font-medium cursor-pointer">
                            {item.properties.map((property, i) => {
                              return (
                                <div className="flex items-center gap-[12px]">
                                  <p
                                    key={property.id || i}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePropertyClick(item, property);
                                    }}
                                    className="w-fit text-primary-black font-medium text-[14px] md:hover:text-secondary-rectangle-one select-none cursor-pointer"
                                  >
                                    {property?.name}
                                  </p>
                                  {i !== item.properties.length - 1 && (
                                    <p className="text-gray font-normal text-[14px]">
                                      /
                                    </p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                    </div>
                  );
                }

                return null;
              })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isOpen && (
        <>
          {/* Dark overlay */}
          <div
            className="fixed inset-0 bg-primary-black bg-opacity-50 z-[100] transition-opacity duration-300"
            onClick={() => {
              onClose();
              setActiveSubmenu(null);
            }}
          />

          {/* Menu container */}
          <div className="fixed top-0 right-0 h-full w-full max-w-[500px] bg-primary-bg z-[9999] lg:z-[9999999999] transform transition-transform duration-300 ease-in-out">
            <div className="flex flex-col h-full relative z-[103]">
              {activeSubmenu ? (
                renderSubmenu(activeSubmenu)
              ) : (
                <>
                  {/* Header */}
                  <div className="h-[55px] lg:h-[80px] px-[16px] shadow-hamburger-menu-shadow bg-primary-black flex justify-between items-center flex-shrink-0">
                    <Link to="/" onClick={onClose}>
                      <img
                        src={logo}
                        alt="Company Logo"
                        className="w-[83px] h-[24px] xxs:w-[93px] xxs:h-[24px] md:w-[127px] md:h-[42px] shrink-0"
                      />
                    </Link>

                    <div className="flex items-center gap-[4px] xxs:gap-[8px] lg:gap-[12px]">
                      <Button
                        innerText="Find Rooms"
                        innerClass="text-pure-white lg:hover:text-primary-black font-bold text-[12px] md:text-[14px] shrink-0"
                        outerClass="shadow-btn-shadow border-secondary-rectangle-one lg:hover:border-pure-white curved-hover flex items-center justify-center border border-secondary-rectangle-one h-[30px] w-fit md:h-[36px] md:w-[120px] rounded-[8px] px-[12px] py-[8px] lg:px-[18px] 2xl:px-[28px] 2xl:py-[12px] bg-secondary-rectangle-one"
                        outerStyle={{
                          "--hover-bg-color": "#ffffff",
                          "--hover-text-color": "#000000",
                        }}
                        onClick={() => {
                          //navigate("/find-your-room/move-in");
                          window.open(`/find-your-room/move-in`, "_blank");
                          onClose();
                        }}
                      />
                      <div
                        className={`mr-8 xxs:mr-10 px-[8px] xxs:px-[12px] w-[60px] xxs:w-[72px] h-[30px] rounded-full lg:hidden flex items-center justify-between border border-secondary-gray/30 bg-pure-white/15`}
                      >
                        <button>
                          <WhatsAppIcon
                            className={`w-[12px] h-[12px] xxs:w-[16px] xxs:h-[16px] text-pure-white`}
                          />
                        </button>
                        <p className="text-secondary-gray/30">|</p>
                        <button>
                          <PhoneSolidIcon
                            className={`w-[12px] h-[12px] xxs:w-[14px] xxs:h-[14px] text-pure-white`}
                          />
                        </button>
                      </div>
                      <button onClick={onClose}>
                        <CrossIcon className="w-[16px] h-[16px] text-pure-white shrink-0" />
                      </button>
                    </div>
                  </div>

                  {/* Main menu options */}
                  <div className="flex-1 flex flex-col min-h-0 px-[16px] py-[30px]">
                    <div className="flex-1 overflow-y-auto no-scrollbar [--webkit-overflow-scrolling:touch]">
                      {navigationOptions.map((option, index) => {
                        const Icon = option.icon;
                        return (
                          <button
                            key={option.id}
                            onClick={() =>
                              option.onClick
                                ? option.onClick()
                                : handleSubmenuClick(option)
                            }
                            className={`w-full text-left flex items-center gap-[8px] text-primary-black md:hover:text-secondary-rectangle-one ${
                              index === navigationOptions.length - 1
                                ? "border-b-0"
                                : "border-b-[1px] border-secondary-gray"
                            } ${option.mobileOnly ? "lg:hidden" : ""}`}
                          >
                            <p className="py-[12px] font-medium text-[16px]">
                              {option.text}
                            </p>
                            {Icon && (
                              <Icon className="w-[12px] h-[12px] text-primary-black" />
                            )}
                          </button>
                        );
                      })}
                    </div>

                    {/* Footer buttons */}
                    <div className="flex flex-col gap-[18px] flex-shrink-0 mt-[12px]">
                      <div className="flex flex-col gap-[12px]">
                        <Button
                          onClick={() => {
                            //navigate("/book-a-viewing/the-railyard");
                            window.open(
                              `/book-a-viewing/the-railyard`,
                              "_blank"
                            );
                            onClose();
                          }}
                          innerText="Book a Viewing"
                          innerClass="font-bold text-[14px] text-pure-white"
                          outerClass="curved-hover h-[50px] flex items-center justify-center w-full border border-secondary-rectangle-one lg:hover:border-primary-black rounded-[8px] px-[16px] py-[12px] bg-secondary-rectangle-one"
                          outerStyle={{
                            "--hover-bg-color": "#FDF7F2",
                            "--hover-text-color": "#0A1F1A",
                          }}
                        />
                        <div className="flex items-center gap-[7px]">
                          <div className="relative flex lg:hidden items-center justify-center h-[50px] rounded-[8px] px-[16px] py-[12px] bg-transparent w-full border border-primary-black">
                            <button
                              ref={languageToggleRef}
                              className="flex items-center justify-center gap-[8px]"
                              onClick={toggleLanguageMenu}
                            >
                              {FlagIcon && (
                                <FlagIcon className="w-[24px] h-[24px] shrink-0 rounded-full" />
                              )}
                              <div className="flex items-center gap-[4px] flex-1">
                                <span className="font-bold text-[14px] text-primary-black">
                                  {selectedLanguage.label}
                                </span>
                                <ChevronDownIcon
                                  className={`w-[12px] h-[12px] shrink-0 transition-transform duration-200 text-primary-black ${
                                    isLanguageMenuOpen ? "rotate-180" : ""
                                  }`}
                                />
                              </div>
                            </button>
                            {isLanguageMenuOpen && (
                              <div
                                ref={languageMenuRef}
                                className="absolute z-[100] bottom-full left-0 mb-[6px]"
                              >
                                <LanguageMenu
                                  options={options}
                                  onSelect={handleLanguageSelect}
                                />
                              </div>
                            )}
                          </div>

                          <Button
                            onClick={() => {
                              window.open(`/contact-us`, "_blank");
                              onClose();
                            }}
                            innerText="Contact Us"
                            innerClass="font-bold text-[14px] text-primary-black"
                            outerClass="curved-hover h-[50px] flex items-center justify-center w-full border border-primary-black lg:hover:border-secondary-rectangle-one rounded-[8px] px-[16px] py-[12px] bg-transparent"
                            outerStyle={{
                              "--hover-bg-color": "#EB5D37",
                              "--hover-text-color": "#ffffff",
                            }}
                          />
                        </div>
                      </div>
                      <div className="border-t-[1px] border-pure-white/15" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HamburgerMenu;
